import { MultiSelect } from '@studio/design-system/multi-select';
import { useState } from 'react';
import type { ReactElement } from 'react';
import { Column, Exhibit } from './styled.jsx';

/** `<Selects>` exhibit. */
export const MultiSelects = (): ReactElement => {
  const [value, setValue] = useState<{ label: string; value: string }[]>([]);

  return (
    <Exhibit title='Selects'>
      <div className='flex gap-40'>
        <Column>
          <MultiSelect onChange={setValue} value={value} />
        </Column>
      </div>
    </Exhibit>
  );
};
